<script>
  import { onMount } from "svelte";
  
    import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
    import Conexoes from "../../Classes/Conexoes.js";
   
    
  export let id;
  export let movimento = {
    nome: '',
    repeticoes: '',
  };
  let isLoading=false;
  let conexao = new Conexoes();

  let  config_drop_down=  {
                api: "consultas.php",
                parametros: {
                    query_code: "consulta_generica_livre",
                    tabela: "movimentos_treino",
                },
                nome_coluna_opcoes: "descricao",
                nome_coluna_saida: "id",
                filtravel: true,
                itens: "",
            };



/*

  onMount(() => {
    const input = document.getElementById(`nome-${id}`);
    const optionsContainer = document.getElementById(`combobox-options-${id}`);

    input.addEventListener('focus', () => {
      filterOptions(); // Mostrar opções ao focar no input
    });

    input.addEventListener('blur', () => {
      setTimeout(() => optionsContainer.style.display = 'none', 200); // Esconde as opções após perder o foco com um pequeno atraso para permitir clique
    });

    function filterOptions() {
      const filter = input.value.toLowerCase();
      optionsContainer.innerHTML = '';

      jsonData.forEach(item => {
        if (item.nome.toLowerCase().includes(filter)) {
          const option = document.createElement('div');
          option.className = 'combobox-option';
          option.textContent = item.nome;
          option.addEventListener('click', () => {
            input.value = item.nome;
            optionsContainer.style.display = 'none';
          });
          optionsContainer.appendChild(option);
        }
      });

      if (optionsContainer.childElementCount > 0) {
        optionsContainer.style.display = 'block';
      } else {
        optionsContainer.style.display = 'none';
      }
    }

    input.addEventListener('input', filterOptions);
  });


  */
</script>

<div class="movimento-container">
  <!--
  <div class="combobox-container">
    <label for="nome-{id}">Nome do Movimento:</label>
    <input type="text" id="nome-{id}" bind:value={movimento.nome} placeholder="Nome do Movimento" />
    <div id="combobox-options-{id}" class="combobox-options"></div>
  </div>
-->

  <DropDownDb config={config_drop_down} bind:saida={movimento.nome} />
  <label for="repeticoes-{id}">Repetições:</label>
  <input
    type="number"
    id="repeticoes-{id}"
    bind:value={movimento.repeticoes}
    placeholder="Repetições"
  />
</div>

<style>
  .combobox-container {
    position: relative;
    width: 100%; /* Ajuste conforme necessário */
  }

  .combobox-options {
    position: absolute;
    border: 1px solid #ccc;

    padding: 10px; /* Espaçamento interno */
    border-radius: 6px; /* Bordas arredondadas */

    background-color: white;
    z-index: 1000;
    overflow-y: auto;
    width: 100%;
    display: none; /* Oculta a lista por padrão */
  }

  .combobox-option {
    padding: 10px;
    cursor: pointer;
  }

  .combobox-option:hover {
    background-color: #f0f0f0;
  }

  .movimento-container {
    border: 2px solid #000; /* Cor do contorno */
    border-radius: 8px; /* Bordas arredondadas */
    padding: 16px; /* Espaçamento interno */
    margin: 16px auto; /* Espaçamento superior e inferior de 16px, centralizado horizontalmente */
    max-width: 750px; /* Largura máxima de 500 pixels */
    width: 100%; /* Largura 100% para telas menores */
    box-sizing: border-box; /* Inclui padding e border na largura total */
  }

  label {
    display: block;
    flex-direction: column;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  input[type="text"],
  input[type="number"] {
    width: 100%; /* Ocupa toda a largura da div */
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  input[type="text"]:focus,
  input[type="number"]:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
  }

  input[type="text"]:disabled,
  input[type="number"]:disabled {
    background-color: #f5f5f5;
    color: #aaa;
  }
</style>
